<script>
import { Validator, } from "@/plugins/validator";
import { metaFields } from "./metaFields";

export default {
    name: "RegisterPatientForm",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 
                rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
            fileno:'',
            patient: {
                patientid: this.$route.params.patientID ? this.$route.params.patientID : 0,
                dob: window.moment().format('YYYY-MM-DD'),
                username: this.$root.username,
                isblocked: "false",
                isspecial:false,
                opfileno: this.$route.params.patientID ? this.fileno : '',
                
            },
            errors: [],
            employmentStatuses: [],
            genders: [],
            calcAge: false,
            maritalStatuses: [],
            locations: [],
            sublocations: [],
            counties: [],
            viewSimilarPatients: false,
            similarPatients: [],
        };
    },

    watch: {

        "patient.firstname"() {
            if(this.patient.firstname) {
                this.errors.filter(error => {
                    if(error.field == `firstname`) {
                        error.message = ``;
                    }
                });
            }
        },
        "patient.lastname"() {
            if(this.patient.lastname) {
                this.errors.filter(error => {
                    if(error.field == `lastname`) {
                        error.message = ``;
                    }
                });
            }
        },
        "patient.nationalid"() {
            if(this.patient.nationalid) {
                this.errors.filter(error => {
                    if(error.field == `nationalid`) {
                        error.message = ``;
                    }
                });
            }
        },
        "patient.dob"() {
            if(this.patient.dob) {
                this.errors.filter(error => {
                    if(error.field == `dob`) {
                        error.message = ``;
                    }
                });
            }
        },
        "patient.cellphone" () {
            if(this.patient.cellphone) {
                this.errors.filter(error => {
                    if(error.field == `cellphone`) {
                        error.message = ``;
                    }
                });
            }
        },
        "patient.genderid" () {
            if(this.patient.genderid) {
                this.errors.filter(error => {
                    if(error.field == `genderid`) {
                        error.message = ``;
                    }
                });
            }
        },
        "patient.countyid" () {
            if(this.patient.countyid){
this.locations=this.locations.filter(g=>g.countyid==this.patient.countyid);
            }
        }
        ,
        "patient.locationid"(){
            if(this.patient.locationid){
                this.sublocations=this.sublocations.filter(g=>g.locationid==this.patient.locationid);
            }
        }
    },
    computed: {
    opfilen() {
      return {
        opfileno: this.$route.params.patientID ? this.fileno : '',
      };
    },
  },

    components: {

        "insurance-tab-form": () => import('./new-tabs/Insurance.vue'),
        "document-management-tab-form": () => import('./new-tabs/DocumentManagement.vue'),
        "next-of-kin-tab-form": () => import('./new-tabs/NextOfKin.vue'),
        "questionaire-tab-form": () => import('./new-tabs/Questionnaire.vue'),
        "age-calculator-form": () => import('./modals/AgeCalculator.vue'),
        "similar-patients-action": () => import('./modals/SimilarPatientsAction.vue'),
    },

    mounted() {

        this.$root.loading = true;
        Promise.allSettled([
         this.fetchEmploymentStatus(), this.fetchGenders(),
         this.fetchMaritalStatus(), this.fetchLocations(),
         this.fetchSublocations(), this.fetchCounties(),
         this.fetchPatient(),this.fetchOpFileNo(),
        ]).then(() => {
            this.$root.loading = false;
        }).catch(() => {
            this.$root.loading = false;
        });
    },

    methods: {

        fetchEmploymentStatus() {

            return this.$http.get(`Shared/GetEmploymentStatus`).then(response => {
                this.employmentStatuses = response.data;
            }).catch(() => {});
        },

        fetchGenders() {

            return this.$http.get(`Shared/GetGender`).then(response => {
                this.genders = response.data;
            }).catch(() => {});
        },

        fetchMaritalStatus() {

            return this.$http.get(`Shared/GetMaritalStatus`).then(response => {
                this.maritalStatuses = response.data;
            }).catch(() => {});
        },
        fetchOpFileNo() {

return this.$http.get(`PatientRegistration/GetOpFileNo`).then(response => {
   // this.patient.opfileno=response.data;
    //this.fileno=response.data;
    if(!this.$route.params.patientID){
        this.patient.opfileno=response.data;
    }else{
        this.fileno=response.data;
    }
   // this.patient.opfileno= this.$route.params.patientID ? '' :response.data;
}).catch(() => {});
},
        fetchLocations() {

            return this.$http.get(`MasterData/GetLocations`).then(response => {
                this.locations = response.data;
            }).catch(() => {});
        },

        fetchSublocations() {

            return this.$http.get(`MasterData/GetSubLocations`).then(response => {
                this.sublocations = response.data;
            }).catch(() => {});
        },

        fetchCounties() {

            return this.$http.get(`MasterData/GetCounties`).then(response => {
                this.counties = response.data;
            }).catch(() => {});
        },

        fetchPatient() {

            if(!this.$route.params.patientID) {

                return new Promise((resolve, reject) => {
                    resolve(); reject();
                });
            }

            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
                this.patient.dob = window.moment(this.patient.dob).format('YYYY-MM-DD');
                this.patient.cellphone = this.patient.celL_PHONE;
                this.patient.patientid = this.patient.patienT_ID;
                this.patient.othercellphone = this.patient.otheR_PHONE;
            }).catch(() => {});
        },

        fetchSimilarPatients() {

            let url = `PatientRegistration/GetPatientsWithSimilarNames`;
                url += `?FirstName=${this.patient.firstname}`;
                url += `&LastName=${this.patient.lastname}`;

            return this.$http.get(url).then(response => {
                    this.similarPatients = response.data;
                    this.viewSimilarPatients=true;
                }).catch(() => { });
        },  

        calculateDOB(age) {
            if(!age) return;
            this.calcAge = false;
            this.patient.dob = window.moment().subtract(parseInt(age), 'years').format('YYYY-MM-DD');
        },
        saveDataMirror() {
            const patient = {
                ...this.patient,
                ignoreSimilarNames: true,
            };

              this.$root.loading = true;
                this.$http.post(`PatientRegistration/PatientDetails`, patient).then(response => {
                    this.errors = [];
                    this.$root.loading = false;
                    window.Swal.fire({ text: response.data.msg, type: 'success', });
                   
                    
                    
                }).catch((error) => { 
                    this.$root.loading=false;
                    if(error.response.data.message == `Other Patient Details similar`) {
                        this.fetchSimilarPatients().then(() => {});
                    }
                });
             
        },
        saveData(ignore = false) {
            const patient = {
                ...this.patient,
                ignoreSimilarNames: ignore ? true : false,
            };

            new Validator(patient, metaFields).validate().then(() => {
                this.$root.loading = true;
                this.$http.post(`PatientRegistration/PatientDetails`, patient).then(response => {
                    this.errors = [];
                    this.$root.loading = false;
                    window.Swal.fire({ text: response.data.msg, type: 'success', });
                  // this.saveDataMirror();
                    if(this.$route.params.patientID) {
                        return;
                    }
                    this.patient.patientid = response.data.patientid;
                    this.$router.push({
                        name : `registration.patient-management.edit`, 
                        params: {
                            patientID: response.data.patientid
                          },
                        });
                    
                }).catch((error) => { 
                    this.$root.loading=false;
                    if(error.response.data.message == `Other Patient Details similar`) {
                        this.fetchSimilarPatients().then(() => {});
                    }
                });
            }).catch(errors => { this.errors = errors; }); 
        },  
       
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <h5 class="font-medium">Patient Management - 
                    {{ $route.params.patientID ?  `Modify` : `Add` }} Patient</h5>
              </template>
              <template v-slot:card-body>
                  <div class="flex md:flex-row sm:flex-col content-start overflow-auto" >
                      <div class="md:w-7/12 sm:w-full flex flex-wrap content-start border-2 
                        border-blue-500 rounded-md">
                            <div class="w-full p-tiny bg-blue-500">
                                <h5 class="font-bold text-sm text-white">Bio Data</h5>
                            </div>
                            <div class="md:w-1/6 sm:w-full p-tiny">
                              <label for="grid-first-name" class="label-control">
                                  First Name <i class="fa fa-asterisk text-red-400"></i>:</label>
                              <input type="text" v-model.trim="patient.firstname" 
                                id="grid-first-name" class="input-control input-sm text-tiny">
                              <p class="form-text-error" 
                                v-if="errors.filter(error => error.field == 'firstname').length">
                                    {{ errors.filter(error => error.field == 'firstname')[0].message }}</p>
                            </div>
                            <div class="md:w-1/6 sm:w-full p-tiny">
                              <label for="grid-middle-name" class="label-control">
                                  Middle Name <i class="fa fa-asterisk text-red-400"></i>:</label>
                              <input type="text" v-model.trim="patient.middlename" 
                                id="grid-middle-name" class="input-control input-sm text-tiny">
                              <p class="form-text-error" 
                                v-if="errors.filter(error => error.field == 'middlename').length">
                                    {{ errors.filter(error => error.field == 'middlename')[0].message }}</p>
                            </div>
                            <div class="md:w-1/6 sm:w-full p-tiny">
                              <label for="grid-last-name" class="label-control">
                                  Last Name <i class="fa fa-asterisk text-tiny text-red-400"></i>:</label>
                              <input type="text" v-model.trim="patient.lastname" 
                                id="grid-last-name" class="input-control input-sm text-tiny">
                              <p class="form-text-error" 
                                v-if="errors.filter(error => error.field == 'lastname').length">
                                    {{ errors.filter(error => error.field == 'lastname')[0].message }}</p>
                            </div>
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-dob" class="label-control">DOB: 
                                    <i class="fa fa-asterisk text-red-400 text-tiny"></i> <a href="javascript:void(0)" @click.prevent="calcAge=true" class="p-tiny rounded bg-blue-600 text-gray-200 text-tiny">Calculate Age</a> </label>
                                    <label for="grid-dob" class="label-control">DOB (mm/dd/yyyy): 
                                    <i class="fa fa-asterisk text-red-400 text-tiny"></i></label>
                                <input type="date" v-model.trim="patient.dob" 
                                    id="grid-dob" class="input-control input-sm text-tiny">
                                <p class="form-text-error" 
                                    v-if="errors.filter(error => error.field == 'dob').length">
                                    {{ errors.filter(error => error.field == 'dob')[0].message }}</p>
                            </div>
                            <age-calculator-form @parseAge="calculateDOB" :showModal="calcAge" @closeModal="calcAge=false"></age-calculator-form>
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-gender" class="label-control">Gender: <i class="fa fa-asterisk text-red-400 text-tiny"></i></label>
                                <tail-select>
                                    <template v-slot:field>
                                        <select v-model="patient.genderid" id="grid-gender" 
                                            class="input-control input-sm text-tiny">
                                            <option v-for="(gender,idx) in genders" 
                                                :value="gender.genderID" :key="idx">{{ gender.gender }}</option>
                                        </select>
                                    </template>
                                </tail-select>
                                <p class="form-text-error" 
                                    v-if="errors.filter(error => error.field == 'genderid').length">
                                        {{ errors.filter(error => error.field == 'genderid')[0].message }}</p>
                            </div>
                            <div class="md:w-1/6 sm:w-full p-tiny">
                                <label for="grid-marital-status" class="label-control">Marital Status:</label>
                                <tail-select>
                                    <template v-slot:field>
                                        <select id="grid-marital-status" v-model="patient.maritalstatusid" 
                                            class="input-control input-sm text-xs">
                                            <option v-for="(mStatus,idx) in maritalStatuses" 
                                                :key="idx" :value="mStatus.statusID">{{ mStatus.status }}</option>
                                        </select>
                                    </template>
                                </tail-select>
                            </div>
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-opfileno" class="label-control">OP File No:</label>
                                <input type="text" v-model.trim="patient.opfileno" disabled  
                                    id="grid-opfileno" class="input-control input-sm text-tiny">
                            </div>
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-ipfileno" class="label-control">IP File No:</label>
                                <input type="text" v-model.trim="patient.ipfileno" 
                                    id="grid-ipfileno" class="input-control input-sm text-tiny">
                            </div>
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-id-number" class="label-control">ID/Passport No
                                        <i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text" v-model.trim="patient.nationalid" 
                                    id="grid-id-number" class="input-control input-sm text-tiny">
                                <p class="form-text-error" 
                                    v-if="errors.filter(error => error.field == 'nationalid').length">
                                        {{ errors.filter(error => error.field == 'nationalid')
                                            .map(error => error.message).join(',') }}</p>
                            </div>
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-c-id-number" class="label-control">Confirm ID/Passport 
                                        <i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text" v-model.trim="patient.cNationalid" 
                                    id="grid-c-id-number" class="input-control input-sm text-tiny">
                            </div>
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-employment" class="label-control">
                                    Employment <i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <tail-select>
                                    <template v-slot:field>
                                        <select id="grid-employment" v-model="patient.employmentstatusid" 
                                            class="input-control input-sm text-tiny">
                                            <option value="">Employment type</option>
                                            <option v-for="(empStatus, idx) in employmentStatuses" 
                                                :value="empStatus.employmentStatusId" :key="idx">
                                                    {{ empStatus.employmentStatus }}</option>
                                        </select>
                                    </template>
                                </tail-select>
                                <p class="form-text-error" 
                                    v-if="errors.filter(error => error.field == 'employmentstatusid').length">
                                    {{ errors.filter(error => error.field == 'employmentstatusid')[0].message }}</p>
                            </div>
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-employer" class="label-control">
                                    Employer <i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text"  v-model.trim="patient.employer" 
                                    id="grid-employer" class="input-control input-sm text-tiny">
                                <p class="form-text-error" 
                                    v-if="errors.filter(error => error.field == 'employmentstatusid').length">
                                    {{ errors.filter(error => error.field == 'employmentstatusid')[0].message }}</p>
                            </div>
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-occupation" class="label-control">Occupation<i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text" v-model.trim="patient.occupation" 
                                    id="grid-occupation" class="input-control input-sm text-tiny">
                                    <p class="form-text-error" 
                                    v-if="errors.filter(error => error.field == 'occupation').length">
                                    {{ errors.filter(error => error.field == 'occupation')[0].message }}</p>
                            </div>
                            <!-- <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-email-address" class="label-control">Next of Kin<i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text" 
                                    v-model.trim="patient.nextOfKin" 
                                    id="grid-email-address" 
                                    class="input-control input-sm text-tiny">
                            </div>   <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-occupation" class="label-control">Relationship<i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text" v-model.trim="patient.nextOfkinRelationship" 
                                    id="grid-occupation" class="input-control input-sm text-tiny">
                                    <p class="form-text-error" 
                                    v-if="errors.filter(error => error.field == 'occupation').length">
                                    {{ errors.filter(error => error.field == 'occupation')[0].message }}</p>
                            </div>
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-email-address" class="label-control">Next Of Kin ID<i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text" 
                                    v-model.trim="patient.nextOfkinID" 
                                    id="grid-email-address" 
                                    class="input-control input-sm text-tiny">
                            </div>   <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-occupation" class="label-control">Next Of Kin Phone <i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text" v-model.trim="patient.nextOfkinTelephone" 
                                    id="grid-occupation" class="input-control input-sm text-tiny">
                                    <p class="form-text-error" 
                                    v-if="errors.filter(error => error.field == 'occupation').length">
                                    {{ errors.filter(error => error.field == 'occupation')[0].message }}</p>
                            </div> -->
                            <div class="md:w-1/6 sm:w-1/2 p-tiny">
                                <label for="grid-email-address" class="label-control">Email:</label>
                                <input type="text" 
                                    v-model.trim="patient.emailaddress" 
                                    id="grid-email-address" 
                                    class="input-control input-sm text-tiny">
                            </div>
                             
                            <div class="md:w-1/12 sm:w-1/2 p-tiny"  v-if="$root.checkAuth('AddSpecialPatients')">
                <input
                  type="checkbox"
                  v-model.trim="patient.isspecial"
                  class="mt-5"
                />
              </div>
                        </div>
                        <div class="md:w-4/12 sm:w-full flex flex-wrap content-start border-2 
                            border-blue-500 rounded-md">
                            <div class="w-full p-tiny bg-blue-500">
                                <h5 class="font-bold text-base text-white">Contact Information</h5>
                            </div>
                            <div class="md:w-1/3 sm:w-1/2 p-tiny">
                                <label for="grid-cellphone-number" 
                                    class="label-control">Cellphone 
                                        <i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text" v-model.trim="patient.cellphone" 
                                    id="grid-cellphone-number" class="input-control input-sm text-tiny">
                                <p class="form-text-error" 
                                    v-if="errors.filter(error => error.field == 'cellphone').length">
                                    {{ errors.filter(error => error.field == 'cellphone')
                                        .map(error => error.message).join(',') }}</p>
                            </div>
                            <div class="md:w-1/3 sm:w-1/2 p-tiny">
                                <label for="grid-c-cellphone-number" 
                                    class="label-control">Cellphone 
                                        <i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text" 
                                    v-model.trim="patient.cCellphone" 
                                    id="grid-c-cellphone-number" 
                                    class="input-control input-sm text-tiny">
                            </div>
                            <div class="md:w-1/3 sm:w-1/2 p-tiny">
                                <label for="grid-other-cellphone-number" 
                                    class="label-control">Other Cellphone:</label>
                                <input type="text" v-model.trim="patient.othercellphone" 
                                    id="grid-other-cellphone-number" 
                                    class="input-control input-sm text-tiny">
                            </div>
                            <div class="md:w-1/3 sm:w-1/2 p-tiny">
                                <label for="grid-residence" class="label-control">Current Residence<i class="fa fa-asterisk text-red-400 text-tiny"></i>:</label>
                                <input type="text"  v-model.trim="patient.residence" 
                                    id="grid-residence" class="input-control input-sm text-tiny">
                                <p class="form-text-error" 
                                    v-if="errors.filter(error => error.field == 'residence').length">
                                    {{ errors.filter(error => error.field == 'residence')[0].message }}</p>
                            </div>
                            <div class="md:w-1/3 sm:w-full p-tiny">
                                <label for="grid-county" class="label-control">County:</label>
                                <tail-select>
                                    <template v-slot:field>
                                        <select id="grid-county" 
                                            v-model="patient.countyid" 
                                            class="input-control input-sm text-xs">
                                            <option value="">Select county</option>
                                            <option v-for="(county,idx) in counties" :key="idx" 
                                                :value="county.countyid">{{ county.county }}</option>
                                        </select>
                                    </template>
                                </tail-select>
                            </div>
                            <div class="md:w-1/3 sm:w-full p-tiny">
                                <label for="grid-location" class="label-control">Location:</label>
                                <tail-select>
                                    <template v-slot:field>
                                        <select id="grid-location" v-model="patient.locationid" 
                                            class="input-control input-sm text-xs">
                                            <option value="">Select location</option>
                                            <option v-for="(location,idx) in locations" 
                                                :key="idx" :value="location.locationid">
                                                    {{ location.location }}</option>
                                        </select>
                                    </template>
                                </tail-select>
                            </div>
                            <div class="md:w-1/3 sm:w-full p-tiny">
                                <label for="grid-sublocation" class="label-control">Sub-Location:</label>
                                <tail-select>
                                    <template v-slot:field>
                                        <select id="grid-sublocation" 
                                            v-model="patient.sublocationid" class="input-control input-sm text-xs">
                                            <option value="">Select sublocation</option>
                                            <option v-for="(sublocation,idx) in sublocations" 
                                                :key="idx" :value="sublocation.sublocationid">
                                                    {{ sublocation.sublocation }}</option>
                                        </select>
                                    </template>
                                </tail-select>
                            </div>
                        </div>
                        <div class="md:w-1/12 sm:w-full flex flex-wrap content-start border-2 
                            border-blue-500 rounded-md overflow-auto">
                            <div class="h-24 w-24 border-2"></div>
                            <input type="file" 
                                class="input-sm text-xs input-control" accept="image/*" capture="user">
                        </div>
                  </div>
                  <div class="flex flex-col content-start p-tiny overflow-auto" style="height:52vh;">
                      <ul class="w-full flex border-b-2 border-gray-500" 
                        v-if="$route.params.patientID">
                          <li class="-mb-px mr-1">
                              <a href="javascript:void(0)" 
                                @click.prevent="$route.params.patientID ? active=0 : ``"
                                 class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold 
                                    whitespace-no-wrap" 
                                 :class="active == 0 ? activeClass : inActiveClass">
                                    <i class="fa fa-file-invoice-dollar"></i> Insurance Details</a>
                          </li>
                          <li class="-mb-px mr-1">
                              <a href="javascript:void(0)" 
                                @click.prevent="$route.params.patientID ? active=1 : ``"
                                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold 
                                    whitespace-no-wrap"
                                :class="active == 1 ? activeClass : inActiveClass">
                                    <i class="fa fa-users"></i> Next of kin</a>
                          </li>
                          <li class="-mb-px mr-1">
                              <a href="javascript:void(0)" 
                                @click.prevent="$route.params.patientID ? active=2 : ``"
                                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold 
                                    whitespace-no-wrap"
                                :class="active == 2 ? activeClass : inActiveClass">
                                    <i class="fa fa-file"></i> Document Management</a>
                          </li>
                          <li class="-mb-px mr-1">
                              <a href="javascript:void(0)" 
                                @click.prevent="$route.params.patientID ? active=3 : ``"
                                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold 
                                    whitespace-no-wrap"
                                 :class="active == 3 ? activeClass : inActiveClass">
                                    <i class="fa fa-question"></i> Questionnaire</a>
                          </li>
                        </ul>
                        <div class="w-full" v-if="$route.params.patientID && active==0">
                            <insurance-tab-form :patient="patient"></insurance-tab-form>
                        </div>
                        <div class="w-full" v-if="$route.params.patientID && active==1">
                            <next-of-kin-tab-form></next-of-kin-tab-form>
                        </div>
                        <div class="w-full" v-if="$route.params.patientID && active==2">
                            <document-management-tab-form :patient="patient"></document-management-tab-form>
                        </div>
                        <div class="w-full" v-if="$route.params.patientID && active==3">
                            <questionaire-tab-form></questionaire-tab-form>
                        </div>
                        <similar-patients-action 
                            :similarPatients="similarPatients"
                            :showModal="viewSimilarPatients"
                            @saveSimilar="() => {
                                viewSimilarPatients=false;
                                saveData(true);
                            }"
                            @closeModal="viewSimilarPatients=false"
                        />
                  </div>
              </template>
              <template v-slot:card-footer>
                  <div class="flex justify-end">
                      <router-link 
                        class="btn-sm btn-danger text-sm rounded-md mr-4" 
                        :to="{ name: `registration.patient-management.index`}">
                            <i class="fa fa-caret-left"></i> Back</router-link>
                      <button 
                        class="btn-sm btn-primary text-sm rounded-md" 
                        @click.prevent="saveData(false)">
                            <i class="fa fa-save"></i> Save</button>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
